import { FileFormat, FormCreateScheduleExport, TimeInterval } from './QuickReports.type';

const hoursRange = [...new Array(24)];

export const HOURS_OPTIONS = hoursRange.map((_, index) => ({
  value: index.toString(),
  label: index < 10 ? `0${index}:00` : `${index}:00`
}));

export const INITIAL_VALUES: FormCreateScheduleExport = {
  quickReportUid: '',
  startTimestamp: undefined as unknown as Date,
  hour: undefined,
  timeInterval: 'NEVER',
  fileFormat: 'CSV',
  uid: undefined
};
export const DEFAULT_EXPORT_FILE_FORMATS: FileFormat[] = ['CSV', 'XLSX'];
export const TIME_INTERVALS: TimeInterval[] = ['NEVER', 'DAILY', 'WEEKLY', 'BI_WEEKLY', 'MONTHLY', 'ANNUALLY'];
export const ALL_TIME_INTERVALS: TimeInterval[] = [
  'NEVER',
  'EVERY_4_HOURS',
  'DAILY',
  'WEEKLY',
  'BI_WEEKLY',
  'MONTHLY',
  'ANNUALLY'
];
// TODO: Remove after translate migration
export const TIME_INTERVAL_OPTIONS: { value: TimeInterval; label: string }[] = [
  {
    value: 'NEVER',
    label: 'Never'
  },
  {
    value: 'EVERY_4_HOURS',
    label: 'Every 4 hours'
  },
  {
    value: 'DAILY',
    label: 'Daily'
  },
  {
    value: 'WEEKLY',
    label: 'Weekly'
  },
  {
    value: 'BI_WEEKLY',
    label: 'Bi-Weekly'
  },
  {
    value: 'MONTHLY',
    label: 'Monthly'
  },
  {
    value: 'ANNUALLY',
    label: 'Annually'
  }
];

export const ONE_HOUR_IN_SECONDS = 3600;
export const ONE_HOUR_IN_MILLISECONDS = ONE_HOUR_IN_SECONDS * 1000;
